"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var ChangeLanguage_1 = require("../../ChangeLanguage");
var Currency_1 = require("./Currency");
var Profile_1 = require("./Profile");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var AuthMenu = function (_a) {
    var isNarrowXl = _a.isNarrowXl, languages = _a.languages, withReferral = _a.withReferral, changeLanguageVariant = _a.changeLanguageVariant;
    var t = (0, next_intl_1.useTranslations)('translation');
    var pathname = (0, navigation_1.usePathname)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var showBalance = (0, react_1.useMemo)(function () {
        var isGamePage = /game\/\w*/.test(pathname);
        var isBettingPage = /betting\/\w*/.test(pathname);
        return !isGamePage && !isBettingPage;
    }, [pathname]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.headerProfileWrapper },
        Object.keys(breakpoints).length > 0 &&
            !breakpoints.mobile &&
            !breakpoints.tablet && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Profile_1.Profile, { isNarrowXl: isNarrowXl, withReferral: withReferral }),
            showBalance && react_1.default.createElement(Currency_1.Currency, { isNarrowXl: isNarrowXl }))),
        react_1.default.createElement("div", { onClick: openDeposit, className: "".concat(styles_module_scss_1.default.buttonWrapper, " ").concat(!isNarrowXl ? styles_module_scss_1.default.big : '') },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper" }, t('deposit'))),
        Object.keys(breakpoints).length > 0 &&
            !breakpoints.mobile &&
            !breakpoints.tablet && (react_1.default.createElement(ChangeLanguage_1.ChangeLanguage, { isNarrowXl: isNarrowXl, isAuth: true, languages: languages, variant: changeLanguageVariant }))));
};
exports.default = react_1.default.memo(AuthMenu);
